import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { cliniciansActions } from 'features/clinicians';

const useClinicians = () => {
  const dispatch = useDispatch();
  const getClinicians = useCallback(({ offset, query }) => dispatch(cliniciansActions.getClinicians({ offset, query })), [dispatch]);
  const getClinician = useCallback(id => dispatch(cliniciansActions.getClinician(id)), [dispatch]);
  const createClinician = useCallback(clinician => dispatch(cliniciansActions.createClinician(clinician)), [dispatch]);
  const updateClinician = useCallback(clinician => dispatch(cliniciansActions.updateClinician(clinician)), [dispatch]);
  const deleteClinician = useCallback(id => dispatch(cliniciansActions.deleteClinician(id)), [dispatch]);
  const clearLocalClinicians = useCallback(() => dispatch(cliniciansActions.clearLocalClinicians()), [dispatch]);
  const clearLocalActiveClinician = useCallback(() => dispatch(cliniciansActions.clearLocalActiveClinician()), [dispatch]);

  return {
    getClinicians,
    getClinician,
    createClinician,
    updateClinician,
    deleteClinician,
    clearLocalClinicians,
    clearLocalActiveClinician
  };
};

export default useClinicians;